/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do main 
 */
export default styled.main`
  background-color: #dcddbb;
  color: black;
  height: 100%;
  flex: 1 0 auto;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 100%;

    .palette {
      position: absolute;
      top: 55px;
      left: auto !important;
      right: 15px;
    }

    .leaflet-control-zoom {
      transform: translateY(45px);
    }
  }

  .palette {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 999;
    > div {
      width: 36px;
      height: 36px;
    }
  }

  .bottomRight {
    position: absolute;
    right: 10px;
    bottom: 19px;
    z-index: 1400;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;

    @media (max-width: 768px) {
      width: calc(100% - 20px);
      justify-content: space-between;
    }
  }
`;

export const StyledFooter = styled.div`
    width: 200px;
    height: 80px;
    position: absolute;
    left: 20px;
    bottom: -10px;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 10px;
`;
